import * as React from 'react';
import styled from 'styled-components';
import { SvgLoading } from '../../../Generic/Loaders';
import { DSTableBodyProps, DSTableBody } from '../DSTableBody';

const StyledTableBody = styled(DSTableBody)<{ $height?: string }>`
    position: relative;

    ${props =>
        props.$height &&
        `
            height: ${props.$height};
        `}
`;

const StyledTableRow = styled.tr`
    padding: 0 !important;
    height: 0 !important;
    border: none;
`;

const StyledTableCell = styled.td`
    padding: 0 !important;
    height: 0 !important;
    border: none;
`;

const OverlayDiv = styled.div<{ $disableInteraction?: boolean }>`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    background-color: rgba(255, 255, 255, 0.5);
    z-index: 1;

    ${({ $disableInteraction }) => ($disableInteraction ? '' : 'pointer-events: none;')}
`;

export interface DSTableBodyLoadableProps extends DSTableBodyProps {
    colSpan?: React.TdHTMLAttributes<HTMLTableDataCellElement>['colSpan'];
    disableInteraction?: boolean;
    loader?: JSX.Element;
    loading?: boolean;
    minHeight?: string;
}

export function DSTableBodyLoadable({
    children,
    colSpan,
    disableInteraction = true,
    loader,
    loading,
    minHeight,
    ...props
}: DSTableBodyLoadableProps): JSX.Element {
    let height;

    /*
     * If we dont have any children and we are loading
     * We need to set the min-height
     * Otherwise if we do have children, we only set the min-height if its specified
     * We don't care about the min height if the component is not loading
     */
    if (!children && loading) {
        height = minHeight ?? '50px';
    } else if (children && loading) {
        height = minHeight;
    }

    return (
        <StyledTableBody {...props} $height={height}>
            {children}
            {loading && (
                <StyledTableRow>
                    <StyledTableCell colSpan={colSpan}>
                        <OverlayDiv $disableInteraction={disableInteraction}>
                            {loader ?? <SvgLoading data-cy="loading" />}
                        </OverlayDiv>
                    </StyledTableCell>
                </StyledTableRow>
            )}
        </StyledTableBody>
    );
}
DSTableBodyLoadable.displayName = 'DSTableBodyLoadable';
